export const categoriesSubMenu = [{
  path: '/category/list',
  component: () => import('@/views/category/list.vue'),
  name: 'categories',
  meta: {
    title: 'productManagement.category.title',
    roles: ['Super Admin', 'Admin'],
    noCache: true,
    icon: 'tree',
    hidden: true
  }
}, {
  path: '/category/list/:parentId(\\d+)',
  component: () => import('@/views/category/list.vue'),
  name: 'categories',
  meta: {
    title: 'productManagement.category.title',
    noCache: true,
    hidden: true
  }
}, {
  path: '/category/edit/:id(\\d+)',
  component: () => import('@/views/category/manage.vue'),
  name: 'productManagement.category.manage',
  props: {
    isEdit: true
  },
  meta: {
    title: 'productManagement.category.manage',
    noCache: true,
    activeMenu: '/category/list',
    hidden: true
  }
}, {
  path: '/category/add/:parentId(\\d+)',
  component: () => import('@/views/category/manage.vue'),
  name: 'productManagement.category.manage',
  props: {
    isEdit: false
  },
  meta: {
    title: 'productManagement.category.manage',
    noCache: true,
    activeMenu: '/category/list',
    hidden: true
  }
}];